import {Parser} from "./AbstractParser";

export class ApiResponseTypeParser extends Parser {
    parse() {
        if (this.input === undefined || this.input === null) {
            return "";
        } else if (this.input === "SUCCESS") {
            return "success";
        } else if (this.input === "HAS_WARNINGS") {
            return "warning";
        } else {
            return "error";
        }
    }
}

export class ApiDataParser extends Parser {
    parse() {
        let str = [];
        for (let i in this.input) {
            if (this.input.hasOwnProperty(i)) {
                str.push(encodeURIComponent(i) + "=" + encodeURIComponent(this.input[i]));
            }
        }
        return str.join("&");
    };
}


// WEBPACK FOOTER //
// ./src/parser/ApiParser.js